<template>
  <perseu-card :title="titleDialog">
    <template slot="content">
      <v-form ref="form" @submit.prevent="save">
        <v-text-field
          label="Nome da terapia"
          v-model.trim="therapy.name"
          :rules="[$rules.required]"
        />
      </v-form>
    </template>
    <template slot="actions">
      <v-btn @click="save" color="primary">Salvar</v-btn>
    </template>
  </perseu-card>
</template>

<script>
import { save } from "@/services/complementary-therapies";
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    titleDialog() {
      return (this.therapy.id ? "Editar " : "Nova ") + "Terapia Complementar";
    },
  },
  data: function () {
    return {
      therapy: this.value,
    };
  },
  watch: {
    value(value) {
      this.therapy = value;
    },
  },
  methods: {
    async save(event) {
      if (!this.$refs.form.validate()) return;
      try {
        let { data } = await save(this.therapy);
        if (this.therapy.id) {
          this.$emit("update", data);
        } else {
          this.$emit("create", data);
        }
        this.$toasted.global.defaultSuccess();
      } catch (error) {
        this.$toasted.global.defaultError();
      }
    },
  },
};
</script>

<style></style>
